import state from './moduleHubspotState.js';
import mutations from './moduleHubspotMutations.js';
import actions from './moduleHubspotActions.js';
import getters from './moduleHubspotGetters.js';

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
};
